<template>
<div class="index-content">
  <div class="container">
    <h3>我们的价值观</h3>
    <ul class="index-list" v-if="!imgs.length">
      <li>
        <div class="img">
       
          <img src="../assets/images/value_1.png" alt="" >
          <span>创 新</span>
        </div>
        <p>活力创新</p>
      </li>
      <li>
        <div class="img">
         
          <img src="../assets/images/value_2.png" alt="">
          <span>诚 信</span>
        </div>
        <p>诚信友爱</p>
      </li>
      <li>
        <div class="img">
        
          <img src="../assets/images/value_3.png" alt="" >
          <span>团 结</span>
        </div>
        <p>团结奋斗</p>
      </li>
      <li>
        <div class="img">
         
          <img src="../assets/images/value_4.png" alt="" >
          <span>合 作</span>
        </div>
        <p>合作共赢</p>
      </li>
    </ul>
     <ul class="index-list"  v-else>
      <li v-for="item,index in imgs" :key='index'>
        <div class="img">
          <img :src="imgUrl + item.pic" alt="" v-if="item.pic" class="imgsize">
         
          <!-- <span>创 新</span> -->
        </div>
        <!-- <p>活力创新</p> -->
      </li>
      
    </ul>
  </div>
</div>
</template>

<script>
const imgUrl = "https://ringstar.xhqj71.com/jeecg-boot/sys/common/static/"; //公共路径 

import {
  banner
} from "../api/api"

export default {

  data() {
    return {
      imgUrl: imgUrl,
      imgs: [],
    }
  },
  mounted() {
    this.getbanner();
  },
  methods: {
    getbanner() {
      banner({
        type: 3
      }).then(res => {
        if (res.data.code == 200) {
          console.log(this.imgs)
          this.imgs = res.data.result
          //    console.log(imgUrl + res.data.result[0].pic)
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.index-content {
  padding: 75px 0 40px;
  background-color: #fff;

  h3 {
    margin-bottom: 70px;
  }
}

.index-list {
  li {
    flex: 0 0 24%;
    margin-right: calc(4% / 3);
    margin-bottom: calc(4% / 3);

    &:nth-child(4n) {
      margin-right: 0;
    }
  }

  span {
    position: absolute;
    top: 12px;
    left: 16px;
    padding: 4px 16px;
    border-radius: 4px;
    font-size: 14px;
    color: #ffffff;
    z-index: 8;
    background-color: rgba(0, 0, 0, .3);
  }

  p {
    margin: 40px 0;
    font-size: 16px;
    text-align: center;
  }
}
.imgsize {
   width: 300px;
   height: 183px
}
</style>



// WEBPACK FOOTER //
// src/components/value.vue